// The imports from 'moment' must be included in order for ant-design Calendar to work
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import 'moment/locale/nl';

import en_GB from 'antd/lib/locale-provider/en_GB';
import de_DE from 'antd/lib/locale-provider/de_DE';
import fr_FR from 'antd/lib/locale-provider/fr_FR';
import nl_NL from 'antd/lib/locale-provider/nl_NL';

import User from '../services/User';

class Constants {

  static get LOCALES() {
    return {en: en_GB, de: de_DE, fr: fr_FR, nl: nl_NL}
  }

  static get AUTH_CONSTANTS() {
    return {
      ACCESS_TOKEN_HEADER: "x-connected-token",
      REFRESH_TOKEN_HEADER: "x-connected-refresh-token",
      REFRESH_TOKEN_EXPIRATION: "x-connected-token-expiration",
    }
  }

  static get SUPPORTED_LANGUAGES() {
    return ['en', 'de', 'fr', 'nl'];
  }

  static get SUPPORTED_LANGUAGES_OPTIONS() {
    return this.SUPPORTED_LANGUAGES.map(lang => ({label: {id: lang}, value: lang}));
  }

  static get SUPPORTED_WMIS() {
    return ['WBA', 'X4X', '4US', 'WBS', 'WBY', 'WBW', 'WMW'];
  }

  static get SORT_OPTIONS() {
    return {"ascend": {value: "asc"}, "descend": {value: "desc"}}
  }

  static get GEARBOX_MANUAL() {
    return {"label": {id: "vehicle.gearbox.MANUAL"}, "value": "MANUAL"};
  }

  static get GEARBOX_AUTOMATIC() {
    return {"label": {id: "vehicle.gearbox.AUTOMATIC"}, "value": "AUTOMATIC"};
  }

  static get FUEL_TYPE_DIESEL() {
    return {"label": {id: "vehicle.fuel-type.DIESEL"}, "value": "DIESEL"};
  }

  static get FUEL_TYPE_GASOLINE() {
    return {"label": {id: "vehicle.fuel-type.GASOLINE"}, "value": "GASOLINE"};
  }

  static get FUEL_TYPE_ELECTRIC() {
    return {"label": {id: "vehicle.fuel-type.ELECTRIC"}, "value": "ELECTRIC"};
  }

  static get FUEL_TYPE_HYBRID() {
    return {"label": {id: "vehicle.fuel-type.HYBRID"}, "value": "HYBRID"};
  }

  static get PICKUP_247() {
    return "PICKUP";
  }

  static get DROPOFF_247() {
    return "DROPOFF";
  }

  static get DRIVE_IN_MANDATORY() {
    return "MANDATORY";
  }

  static get DRIVE_IN_ON_REQUEST() {
    return "ON_REQUEST";
  }

  static get DRIVE_IN_NONE() {
    return 'NONE';
  }

  static get CAR_DELIVERY() {
    return {label: {id: 'vehicle.report.delivery'}, value: 'DELIVERY'}
  }

  static get CAR_RETURN() {
    return {label: {id: 'vehicle.report.return'}, value: 'RETURN'}
  }

  static get CALL_CENTER_MOBILITIES() {
    return [this.OWN_MOBILITY, this.NO_MOBILITY, this.ROAD_ASSIST_MOBILITY];
  }

  static get OWN_MOBILITY() {
    return {label: {id: 'call.center.journey.step.serviceMobility.mobilityOwn'}, value: 'own'};
  }

  static get NO_MOBILITY() {
    return {label: {id: 'call.center.journey.step.serviceMobility.noSolution'}, value: 'no'};
  }

  static get ROAD_ASSIST_MOBILITY() {
    return {label: {id: 'call.center.journey.step.serviceMobility.road.assist'}, value: 'road_assist'};
  }

  static get SIGNATURE_REQUESTED_SERVICES() { return {label: {id: 'signature.requested-services'}, value: 'REQUESTED_SERVICES'} }
  static get SIGNATURE_LEGAL_DOCUMENTS() { return {label: {id: 'signature.legal-documents'}, value: 'LEGAL_DOCUMENTS'} }
  static get SIGNATURE_RENTAL_CONTRACT() { return {label: {id: 'signature.rental-contract'}, value: 'RENTAL_CONTRACT'} }
  static get SIGNATURE_DAMAGE_REPORT() { return {label: {id: 'signature.damage-report'}, value: 'DAMAGE_REPORT'} }
  static get SIGNATURE_PERFORMED_SERVICES() { return {label: {id: 'signature.performed-services'}, value: 'PERFORMED_SERVICES'} }

  static get RENTAL_CATEGORIES() {
    return [this.CATEGORY1, this.CATEGORY2, this.CATEGORY3, this.CATEGORY4, this.MOTORBIKE]
  }

  static get CATEGORY1() { return {label: {id: 'mobility.category1'}, value: 'CATEGORY1'} }
  static get CATEGORY2() { return {label: {id: 'mobility.category2'}, value: 'CATEGORY2'} }
  static get CATEGORY3() { return {label: {id: 'mobility.category3'}, value: 'CATEGORY3'} }
  static get CATEGORY4() { return {label: {id: 'mobility.category4'}, value: 'CATEGORY4'} }
  static get MOTORBIKE() { return {label: {id: 'mobility.motorbike'}, value: 'MOTORBIKE'} }

  static get CHOICE_YES() {
    return {id: 'yes'}
  }

  static get CHOICE_NO() {
    return {id: 'no'}
  }

  static get DATE_FORMAT_DISPLAY() {
    return 'DD/MM/YYYY';
  }

  static get DATE_FORMAT_API() {
    return 'YYYY-MM-DD';
  }

  static get TIME_FORMAT_API() {
    return 'HH:mm:ss';
  }

  static get VEHICLE_READY_LIMIT_TO_ANSWER() {
    return 60;
  }

  static get TIME_FORMAT_DISPLAY() {
    return 'HH:mm'
  }

  static get WEEK_DAY() {
    return ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
  }

  static get STATUS_FILTER() {
    return [this.STATUS_OPEN, this.STATUS_OPEN_48, this.STATUS_APPROVED, this.STATUS_ONGOING,
      this.STATUS_HANDLED, this.STATUS_READY_FOR_APPOINTMENT, this.STATUS_NOT_APPROVED, this.STATUS_FINISHED, this.STATUS_CANCELLED, this.STATUS_DELETED]
  }

  static get TYPES() {
    return User.isCallCenterAgent() ? [this.TYPE_MESSAGE, this.TYPE_APPOINTMENT, this.TYPE_PITSTOP] : [this.TYPE_MESSAGE, this.TYPE_APPOINTMENT, this.TYPE_TIRES, this.TYPE_BODYSHOP, this.TYPE_PITSTOP]
  }

  static get ORIGINS() {
    return [this.ORIGIN_MOBILE, this.ORIGIN_CALL_CENTER, this.ORIGIN_WEB, this.ORIGIN_OAS]
  }

  static get BRANDS() {
    return [this.BRAND_BMW, this.BRAND_MINI]
  }

  static get MOBILITY_VEHICLES() { return [...this.MOBILITY_CATEGORIES, ...this.MOBILITY_MOTOS]}
  static get MOBILITY_CATEGORIES() { return ['category1', 'category2', 'category3', 'category4']}
  static get MOBILITY_MOTOS() { return ['motorbike']}

  static get DAY_CLOSED() { return {value: 'CLOSED'} }
  static get DAY_CLOSED_AM() { return {value: 'CLOSED_AM'} }
  static get DAY_CLOSED_PM() { return {value: 'CLOSED_PM'} }
  static get DAY_MIXED() { return {value: 'MIXED'} }
  static get DAY_OVERBOOKED() { return {value: 'OVERBOOKED'} }
  static get DAY_BLOCK_AM() { return {value: 'BLOCK_AM'} }
  static get DAY_BLOCK_PM() { return {value: 'BLOCK_PM'} }
  static get DAY_OPEN() { return {value: 'OPEN'} }
  static get DAY_OPEN_AM() { return {value: 'OPEN_AM'} }
  static get DAY_OPEN_PM() { return {value: 'OPEN_PM'} }
  static get DAY_CONSTRAINT_BLOCK_WAIT_AM() { return {value: 'BLOCK_WAIT_AM'} }
  static get DAY_CONSTRAINT_BLOCK_WAIT_PM() { return {value: 'BLOCK_WAIT_PM'} }
  static get DAY_CONSTRAINT_BLOCK_NON_WAIT_AM() { return {value: 'BLOCK_NON_WAIT_AM'} }
  static get DAY_CONSTRAINT_BLOCK_NON_WAIT_PM() { return {value: 'BLOCK_NON_WAIT_PM'} }

  static get STATUS_OPEN() { return {label: {id:'intervention.status.OPEN'}, value: 'OPEN'} }
  static get STATUS_OPEN_48() { return {label: {id:'intervention.status.OPEN_48'}, value: 'OPEN_48'} }
  static get STATUS_APPROVED() { return {label: {id:'intervention.status.APPROVED'}, value: 'APPROVED'} }
  static get STATUS_ONGOING() { return {label: {id:'intervention.status.ONGOING'}, value: 'ONGOING'} }
  static get STATUS_HANDLED() { return {label: {id:'intervention.status.HANDLED'}, value: 'HANDLED'} }
  static get STATUS_READY_FOR_APPOINTMENT() { return {label: {id:'intervention.status.READY_FOR_APPOINTMENT'}, value: 'READY_FOR_APPOINTMENT'}}
  static get STATUS_NOT_APPROVED() { return {label: {id:'intervention.status.NOT_APPROVED'}, value: 'NOT_APPROVED'} }
  static get STATUS_FINISHED() { return {label: {id:'intervention.status.FINISHED'}, value: 'FINISHED'} }
  static get STATUS_ARCHIVED() { return {label: {id:'intervention.status.ARCHIVED'}, value: 'ARCHIVED'} }
  static get STATUS_CANCELLED() { return {label: {id:'intervention.status.CANCELLED'}, value: 'CANCELLED'} }
  static get STATUS_DELETED() { return {label: {id: 'intervention.status.DELETED'}, value: 'DELETED'} }

  static get TYPE_MESSAGE() { return {label: {id:'intervention.type.MESSAGE'}, value: 'MESSAGE'} }
  static get TYPE_APPOINTMENT() { return {label: {id:'intervention.type.APPOINTMENT'}, value: 'APPOINTMENT'} }
  static get TYPE_TIRES() { return {label: {id:'intervention.type.TIRES'}, value: 'TIRES'} }

  static get TYPE_PITSTOP() { return {label: {id:'intervention.type.PITSTOP'}, value: 'PITSTOP'} }
  static get TYPE_BODYSHOP() { return {label: {id:'intervention.type.BODYSHOP'}, value: 'BODYSHOP'} }

  static get ORIGIN_WEB() { return {label: {id:'intervention.origin.WEB'}, value: 'WEB'} }
  static get ORIGIN_MOBILE() { return {label: {id:'intervention.origin.MOBILE'}, value: 'MOBILE'} }
  static get ORIGIN_CALL_CENTER() { return {label: {id:'intervention.origin.CALL_CENTER'}, value: 'CALL_CENTER'} }
  static get ORIGIN_OAS() { return {label: {id: 'intervention.origin.OAS'}, value: 'OAS'} }

  static get BRAND_BMW() { return {label: {id:'intervention.brand.BMW'}, value: 'BMW'} }
  static get BRAND_BMW_I() { return {label: {id:'intervention.brand.BMWi'}, value: 'BMWi'} }
  static get BRAND_MINI() { return {label: {id:'intervention.brand.MINI'}, value: 'MINI'} }

  static get TIRE_EXCHANGE_TYPE() {
    return [{label: 'appointment.detail.services.tires-exchange.type.WHEELS', value: 'WHEELS'},
            {label: 'appointment.detail.services.tires-exchange.type.TIRES', value: 'TIRES'},
            {label: 'appointment.detail.services.tires-exchange.type.IDK', value: 'IDK'}]
  }

  static get TIRE_EXCHANGE_MODE() {
    return [{label: 'appointment.detail.services.tires-exchange.mode.BRING', value: 'BRING'},
            {label: 'appointment.detail.services.tires-exchange.mode.DONT_BRING', value: 'DONT_BRING'},
            {label: 'appointment.detail.services.tires-exchange.mode.IDK', value: 'IDK'}]
  }

  static get TIRE_REPLACEMENT_TYPE() {
    return [{label: 'appointment.detail.services.tires-replacement.type.WINTER', value: 'WINTER'},
            {label: 'appointment.detail.services.tires-replacement.type.SUMMER', value: 'SUMMER'}]
  }

  static get TIRE_REPLACEMENT_POSITION() {
    return [{label: 'appointment.detail.services.tires-replacement.position.rearLeft', value: 'rearLeft'},
            {label: 'appointment.detail.services.tires-replacement.position.frontLeft', value: 'frontLeft'},
            {label: 'appointment.detail.services.tires-replacement.position.rearRight', value: 'rearRight'},
            {label: 'appointment.detail.services.tires-replacement.position.frontRight', value: 'frontRight'}]
  }

  static get MAX_ID_PICTURES() { return 4; }
  static get ALLOWED_IMAGE_TYPE () { return ".jpg,.jpeg,.png"; }

  static MARKET() {
    return {
      be:{
        marketCode: "BE",
        allowedLanguage:["fr", "nl", "de", "en"],
        getLanguageForMarket:function(locale){
          return this.allowedLanguage.includes(locale) ? locale :  this.allowedLanguage[0];
        }
      },
      lu:{
        marketCode: "LU",
        allowedLanguage:["fr", "de" , "en"],
        getLanguageForMarket:function(locale){
          return this.allowedLanguage.includes(locale) ? locale :  this.allowedLanguage[0];
        }
      },
    };
  }

  static get FILTER_COUNTERS() {
    return {
      interventionStatusCount: [
        this.STATUS_OPEN.value,
        this.STATUS_OPEN_48.value,
        this.STATUS_READY_FOR_APPOINTMENT.value,
        this.STATUS_ONGOING.value,
      ],
      typeCount: [this.TYPE_PITSTOP.value],
    }
  }

}

export default Constants;



// WEBPACK FOOTER //
// ./src/services/Constants.js